import Head from 'next/head'
import React from 'react'

const HeadTags: React.FC = ({ children }) => {
  return <Head>{children}</Head>
}

export default HeadTags
